import type { TitanFeatureFlagConfig } from '../types/TitanFeatureFlag';

/** Flag exists in the catalog but nobody is in variant or control. */
const disabledTitanFeatureFlag: TitanFeatureFlagConfig['audiobooks']['featureOneTrust'] = {
  strategies: [{}],
  rollout: {
    variantPercent: 0,
    controlPercent: 0,
  },
};

export const titanFeatureFlagsConfig: TitanFeatureFlagConfig = {
  galatea: {
    // Back to the pre-#12296 targeting and split now that the re-ask and the pageview inflation are
    // fixed (DEV-6547). EU plus California, 5% variant against a 5% control.
    featureOneTrust: {
      strategies: [{ allEuCountries: true }, { regionCodes: ['CA'] }],
      rollout: {
        variantPercent: 5,
        controlPercent: 5,
      },
    },
    featureDeepLinkingForceInit: {
      strategies: [{}],
      rollout: {
        variantPercent: 0,
        controlPercent: 0,
      },
    },
  },
  // Audiobooks Plus shares Galatea's Saturn and `feature_flag` rows (`app_name = galatea`) but must
  // not inherit Galatea's OneTrust / deeplink rollouts — those would boot OneTrust in a brand whose
  // native config is not guaranteed. Keep both flags off until Audiobooks has its own.
  audiobooks: {
    featureOneTrust: disabledTitanFeatureFlag,
    featureDeepLinkingForceInit: disabledTitanFeatureFlag,
  },
  candyjar: {
    featureOneTrust: {
      strategies: [{}],
      rollout: {
        variantPercent: 0,
        controlPercent: 0,
      },
    },
    featureDeepLinkingForceInit: {
      strategies: [{}],
      rollout: {
        variantPercent: 0,
        controlPercent: 0,
      },
    },
  },
};
